module.exports = __webpack_public_path__ + "img/terrace.ace94df9.svg";